module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"gateway-beacon\"-in-pasadena-california-00b9b4bc2817cab92e39e67a2e47af9c.png";